import {Component, OnInit} from '@angular/core';
import {AppComponent} from "../../app.component";
import {ParticipantViewModel} from "../../models/participant-view-model";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {UserDataStoreService} from "../../services/user-data-store.service";
import {Router} from "@angular/router";
import {AuthenticationService} from "../../services/authentication.service";
import { MerchantService } from '../../services/merchant.service';
import { TerminalService } from '../../services/terminal.service';
import { TerminalConfigService } from '../../services/terminal-config.service';
import { CardAcceptorConfigService } from '../../services/card-acceptor-config.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-right-sidebar',
  templateUrl: './right-sidebar.component.html',
  styleUrls: ['./right-sidebar.component.scss']
})
export class RightSidebarComponent implements OnInit {

  public participants: ParticipantViewModel[];

  public selectedParticipant: number;

  constructor(private _router:Router,
              private rootApp: AppComponent,
              private _authenticationService: AuthenticationService,
              private _userDataStore: UserDataStoreService,
              private _merchantService: MerchantService,
              private _terminalService: TerminalService,
              private _terminalConfigService: TerminalConfigService,
              private _cardAcceptorConfigService:CardAcceptorConfigService,
              private ngxLoader: NgxUiLoaderService) {
    this.participants = this._userDataStore.userParticipants;
    this.selectedParticipant = this._userDataStore.selectedParticipant?.id;
  }

  ngOnInit() {

  }

  public initCounts() {
    this._terminalService.InitTerminalCount();
    this._terminalService.InitTerminalCountActive();
    this._terminalService.InitTerminalCountInactive();
    this._merchantService.InitMerchantCount();
    this._cardAcceptorConfigService.InitCount();
    this._terminalConfigService.InitTermConfigCount();
  }

  public async onChange(): Promise<void> {
    this.ngxLoader.start();
    this.closeMenu();
    await this._authenticationService.refreshSession(this.participants.find(x => x.id == this.selectedParticipant).id);
    await this._router.navigate(['topbarComponent', 'topbar' ]);
    await this._router.navigate(['']);
    this.initCounts();
    this.ngxLoader.stop();
  }

  public closeMenu() {
    if (!!environment.topBarCssVariable) {
      this.rootApp.cssClass = this.rootApp.cssClass = environment.topBarCssVariable;
    } else {
      this.rootApp.cssClass = this.rootApp.cssClass = '';
    }
  }

}
